export const ordersHistoryEmptyMessages = [
  {
    'title': '⏳ Пролонгацій поки немає',
    'description': 'Поліси не потребують оновлення найближчим часом.<br/>Залучайте нових клієнтів — майбутні пролонгації починаються вже сьогодні!',
  },
];
